<template>
  <Container type="card-full">
    <div slot="header">
      <el-button  @click="addDstable">新增</el-button>
      <el-button  @click="delDstable">删除</el-button>
      <el-button  @click="sortDstable">重新排序</el-button>
      <el-button  @click="close">关闭</el-button>
    </div>
    <div class="container">
      <vggrid ref="xGrid" class="vggrid" :list="list" tableheight="700" flexname=""
              :cols="cols"
              :showfooter="false"
              :showPage="false" :resizable="true"
              @cellClick="cellClick"></vggrid>

      <el-form :model="form" ref="form"  class="content ss-fl" v-if="dstableform">
        <el-row>
          <el-col :span="5">
            <el-form-item label="序号" :label-width="formLabelWidth">
              <el-input v-model="form.dstableseq" auto-complete="off" ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="表名" :label-width="formLabelWidth">
              <el-input v-model="form.dstablecode" auto-complete="off" ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="别名" :label-width="formLabelWidth">
              <el-input v-model="form.dstablealias" auto-complete="off" ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="表说明" :label-width="formLabelWidth">
              <el-input v-model="form.dstablename" auto-complete="off" ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="5">
            <el-form-item label="连表方式" :label-width="formLabelWidth">
              <el-select v-model="form.dstablelinkflg" :clearable="true">
                <el-option v-for="(item, index) in dstablelinkflgList" :label="item.label" :value="item.value" :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="15">
            <el-form-item label="连表条件" :label-width="formLabelWidth">
              <el-input v-model="form.dstablelinkexpr" :maxlength="255" type="textarea"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="" :label-width="formLabelWidth">
          <el-button type="primary" @click="saveDstable">保存</el-button>
          <el-button type="danger" @click="delDstable">删除</el-button>
        </el-form-item>
      </el-form>
    </div>
  </Container>
</template>
<script>
  import request from '@/utils/request'
  import utils from '../../assets/js/utils'
  import vggrid from '../common/vggrid'
  export default {
    name: 'dstableForm',
    data () {
      return {
        list: [],
        dstableform: false,
        dstablelinkflgList: [],
        ds: this.$route.params.form,
        cols: [
          { field: 'dstableseq', title: '序号',calculExpr:'', addNewRowFlg: false},
          { field: 'dstablecode', title: '表名',calculExpr:'',addNewRowFlg: false},
          { field: 'dstablealias', title: '别名',calculExpr:'',addNewRowFlg: false},
          { field: 'dstablename', title: '表说明',calculExpr:'',addNewRowFlg: false},
        ],
        form: {},
        loading: true,
        formLabelWidth: '100px'
      }
    },
    activated () {
      this.init()
      this.getDstableList()
      this.getDstablelinkflgList()
    },
    mounted () {
    },
    components: {vggrid},
    methods: {
      async init() {
        this.list = []
        this.dstableform = false
        this.dstablelinkflgList = []
        this.ds = this.$route.params.form
        this.form = {}
      },
      async addDstable () {
        this.dstableform = true
        let maxSeq = 0
        this.list.forEach(item => {
          if (item.dstableseq>maxSeq) {
            maxSeq = item.dstableseq
          }
        })
        maxSeq += 10
        this.form = {
          dstableid: 0,
          dstableseq: maxSeq,
          dstablecode: '',
          dstablealias: '',
          dstablename: '',
          dstablelinkflg: '',
          dstablelinkexpr: ''
        }
      },
      async getDstablelinkflgList() {
        this.dstablelinkflgList = await request({
          url: '/kfgl/syscode/getSysCodeList',
          method: "get",
          params: {syscode: 'dstablelinkflg'}
        })
      },
      async sortDstable () {
        let data = await request({
          url: '/xtgl/ds/sortDstable',
          method: "post",
          data: this.list
        })
        if (data.issuccess === 1) {
          this.getDstableList()
          this.$message.success('排序成功！')
        } else {
          this.$message.error('排序失败！')
        }
      },
      async delDstable () {
        this.$confirm('确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let data = await request({
            url: '/xtgl/ds/delDstable',
            method: "post",
            data: this.form
          })
          if (data.issuccess === 1) {
            this.getDstableList()
            this.$message.success('删除成功！')
          }
        })
      },
      async saveDstable () {
        this.form.dstabledsid = this.ds.dsid
        await request({
          url: '/xtgl/ds/saveDstable',
          method: "post",
          data: this.form
        })
        this.$message.success('操作成功')
        await this.getDstableList()
        this.dstableform = false
      },
      async cellClick (row) {
        this.form = row.row
        if (this.form.dstablehide === 1) {
          this.form.dstablehide = true
        }
        if (this.form.dstablegriggercol === 1) {
          this.form.dstablegriggercol = true
        }
        if (this.form.dstableissum === 1) {
          this.form.dstableissum = true
        }
        this.dstableform = true
      },
      async pagechange (fcPage) {
        this.query.currPage = fcPage.currentPage
        this.query.pageSize = fcPage.pageSize
        this.getDstableList()
      },
      async getDstableList () {
        this.loading = true
        let res = await request({
          method: 'get',
          url: '/xtgl/ds/getDstableListByDsid',
          params: {dsid: this.ds.dsid}
        })
        this.list = res
        this.loading = false
      },
      close () {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: 'dsIndex'})
      }
    },
    filters: {
    }
  }
</script>

<style lang="scss" scoped>
  .container {
    display: flex;
    .vggrid {
      border: 1px solid #d1dbe5;
      width: 400px;
      margin-right: 5px;
    }
    .content {
      width: 100%;
      padding-top: 10px;
      padding-right: 10px;
      border: 1px solid #d1dbe5;
    }
  }
  #menuReportDiv {
    height: 380px;
    overflow: auto;
  }
</style>
